import { Modes } from '@/utils/enums'
import channel from '@/channel'

export default store => {
  // called when the store is initialized
  store.subscribe((mutation) => {
    if (store.getters['report/mode'] === Modes.ReadOnly) {
      const managerId = store.getters['report/managerId']
      channel.triggerCloseNotification(managerId)
    }
  })
}
